import React, { useEffect, useState } from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import { Icon } from "@iconify/react/dist/iconify.js";
import axios from "axios";
import { BaseUrl } from "../../helper/apiHelper";
import toast from "react-hot-toast";

const PackageEnquiry = () => {
  const [selectedCountry, setSelectedCountry] = useState("");
  const [from, setFrom] = useState("");
  const [to, setTo] = useState("");
  const [activeTab, setActiveTab] = useState("CUSTOM");
  
  const [showMessageModal, setShowMessageModal] = useState(false);
      const [messageContent, setMessageContent] = useState("");
  
  const [package_enquiry, setPackageEnquiry] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState("");
  
  
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const [loading, setLoading] = useState(false);
  const handleCountryChange = (e) => {
    const selectedValue = e.target.value;
    setSelectedCountry(selectedValue);
    const countryMap = {
      "CHINA-INDIA": { from: "CHINA", to: "INDIA" },
      "CHINA-CANADA": { from: "CHINA", to: "CANADA" },
      "INDIA-CANADA": { from: "INDIA", to: "CANADA" },
      "INDIA-USA": { from: "INDIA", to: "USA" },
    };
    if (selectedValue === "") {
      setFrom("");
      setTo("");
    } else if (countryMap[selectedValue]) {
      setFrom(countryMap[selectedValue].from);
      setTo(countryMap[selectedValue].to);
    }
  };

  const getPackageEnquiry = async () => {
    setLoading(true);
    try {
      const body = { status: selectedStatus, package_type : activeTab, from : from, to : to };
      const response = await axios.post(
        `${BaseUrl}/get-package-enquiry-master-admin`,
        body
      );
      if (response.status === 200) {
        setPackageEnquiry(response.data.data);
        setCurrentPage(1); // reset to page 1 on fetch
      }
    } catch (error) {
      toast.error(error.response.data.message);
      console.error(error.response.data.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getPackageEnquiry();
  }, [activeTab, selectedStatus, from, to]);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = date.toLocaleString("default", { month: "long" });
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  // Pagination Logic
  const indexOfLast = currentPage * itemsPerPage;
  const indexOfFirst = indexOfLast - itemsPerPage;
  const currentItems = package_enquiry.slice(indexOfFirst, indexOfLast);
  const totalPages = Math.ceil(package_enquiry.length / itemsPerPage);

  return (
    <MasterLayout>
      <Breadcrumb title="Package Enquiry" />

      <div className="col-xxl-12 mb-16">
        <div className="card p-0 overflow-hidden position-relative radius-12 h-100">
          <div className="card-body px-14">
            {/* Status Tabs */}
            <ul className="nav bordered-tab border border-top-0 border-start-0 border-end-0 d-inline-flex nav-pills mb-16">
              {["ALL", "PENDING", "WORK_IN_PROGRESS", "RESOLVED", "CLOSED"].map(
                (status) => (
                  <li key={status} className="nav-item">
                    <button
                      className={`nav-link px-16 py-10 ${
                        selectedStatus === (status === "ALL" ? "" : status)
                          ? "active"
                          : ""
                      }`}
                      onClick={() =>
                        setSelectedStatus(status === "ALL" ? "" : status)
                      }
                    >
                      {status.replace(/_/g, " ")}
                    </button>
                  </li>
                )
              )}
            </ul>
          </div>
        </div>
      </div>
      <div className="col-lg-12">
        <div className="card">
          <div className="card-header py-16 pb-0 px-24 bg-base border d-flex align-items-center justify-content-between flex-wrap">
            <h6 className="text-lg mb-0">Package Enquiry</h6>
            <div style={{ display: "flex", alignItems: "center", gap: "14px" }}>
              {/* Country Filter */}
              <div className="position-relative" style={{ minWidth: "180px" }}>
                {/* <Icon
                  icon="solar:alt-arrow-down-outline"
                  className="position-absolute"
                  style={{
                    right: "12px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    pointerEvents: "none",
                    color: "#6c757d",
                    zIndex: 1,
                  }}
                /> */}
                <select
                  className="form-select form-select-sm pe-5 ps-3 rounded border"
                  style={{ height: "40px" }}
                  value={selectedCountry}
                  onChange={handleCountryChange}
                >
                  {[
                    { value: "", label: "Select Country" },
                    { value: "CHINA-INDIA", label: "CHINA - INDIA" },
                    { value: "CHINA-CANADA", label: "CHINA - CANADA" },
                    { value: "INDIA-CANADA", label: "INDIA - CANADA" },
                    { value: "INDIA-USA", label: "INDIA - USA" },
                  ].map((option) => (
                    <option key={option.value} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </select>
              </div>

              {/* Shipment Type Tabs */}
              <ul className="nav bordered-tab d-inline-flex nav-pills mb-0">
                {["CUSTOM", "FCL", "LCL"].map((tab) => (
                  <li key={tab} className="nav-item">
                    <button
                      className={`nav-link px-16 py-10 ${
                        activeTab === tab ? "active" : ""
                      }`}
                      onClick={() => setActiveTab(tab)}
                    >
                      {tab}
                    </button>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          {/* Table */}
          <div className="card-body">
            {loading ? (
              <div
                className="d-flex justify-content-center align-items-center"
                style={{
                  minHeight: "calc(100vh - 450px)",
                  width: "100%",
                  background: "transparent",
                }}
              >
                <div
                  className="spinner-border"
                  role="status"
                  style={{
                    color: "#243E85",
                    width: "3rem",
                    height: "3rem",
                  }}
                >
                  <span className="visually-hidden">Loading...</span>
                </div>
              </div>
            ) : currentItems.length === 0 ? (
              <div
                className="d-flex justify-content-center align-items-center"
                style={{
                  minHeight: "200px",
                  width: "100%",
                  fontSize: "1.2rem",
                  color: "#243E85",
                  fontWeight: 500,
                }}
              >
                No inquiries found.
              </div>
            ) : (
              <>
                <div className="table-responsive">
                  <table className="table basic-border-table mb-0">
                    <thead>
                      <tr>
                        <th>Date</th>
                        <th>Full Name</th>
                        <th>Email</th>
                        <th>KG</th>
                        <th>LWH</th>
                        <th>Message</th>
                        <th>Status</th>
                        {!(from && to) && <th>Route (From → To)</th>}
                      </tr>
                    </thead>
                    <tbody>
                      {currentItems.map((items, index) => (
                        <tr key={index}>
                          <td>{formatDate(items.createdAt)}</td>
                          <td>{items?.full_name}</td>
                          <td>{items?.email ? items?.email : "-"}</td>
                          <td>{`${items.approx_package_weight} KG`}</td>
                          <td>
                            {items.approx_package_length +
                              " X " +
                              items.approx_package_width +
                              " X " +
                              items.approx_package_height}
                          </td>
                          {/* <td>{items.message}</td> */}

                          <td>
                            <button
                              className="btn btn-link  p-0"
                              style={{ color: "#243E85" }}
                              onClick={() => {
                                setMessageContent(items?.message || "");
                                setShowMessageModal(true);
                              }}
                            >
                              View Message
                            </button>
                          </td>
                          <td>{items.status}</td>
                          {!(from && to) && (
                            <td>{items.from + " -To- " + items.to}</td>
                          )}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                {package_enquiry.length > itemsPerPage && (
                  <div className="d-flex justify-content-between align-items-center mt-3">
                    <span>
                      Page {currentPage} of {totalPages}
                    </span>
                    <div className="btn-group">
                      <button
                        className="btn btn-outline-primary"
                        onClick={() =>
                          setCurrentPage((prev) => Math.max(prev - 1, 1))
                        }
                        disabled={currentPage === 1}
                      >
                        Previous
                      </button>
                      <button
                        className="btn btn-outline-primary"
                        onClick={() =>
                          setCurrentPage((prev) =>
                            Math.min(prev + 1, totalPages)
                          )
                        }
                        disabled={currentPage === totalPages}
                      >
                        Next
                      </button>
                    </div>
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      </div>
      {showMessageModal && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: "rgba(0,0,0,0.5)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 1050,
          }}
        >
          <div className="card" style={{ width: "90%", maxWidth: 490 }}>
            <div className="card-header d-flex justify-content-between align-items-center">
              <h6 className="mb-0">Message</h6>
              <button
                className="btn btn-sm btn-outline-secondary"
                onClick={() => setShowMessageModal(false)}
              >
                Close
              </button>
            </div>
            <div className="card-body">
              {messageContent ? (
                <p style={{ whiteSpace: "pre-wrap" }}>{messageContent}</p>
              ) : (
                <p className="text-muted">No message provided</p>
              )}
            </div>
          </div>
        </div>
      )}
    </MasterLayout>
  );
};

        export default PackageEnquiry;
